import React from 'react';
import { getGame } from '../../lib/minigames';

// Banner above the bottom bar whenever the current player is party to one
// or more non-terminal challenges. Tapping opens the appropriate UI:
//   - pending  → ChallengePanel review mode
//   - active   → MinigameOverlay
//   - completed (recently resolved) → MinigameOverlay (result screen)
export default function PendingChallengeBanner({ challenges, myPlayerId, onOpenReview, onOpenActive, onOpenResult }) {
  const mine = Object.values(challenges || {})
    .filter((c) => c.fromPlayerId === myPlayerId || c.toPlayerId === myPlayerId)
    .filter((c) => c.status === 'pending' || c.status === 'active' || (c.status === 'completed' && !c.dismissedAt))
    .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
  if (mine.length === 0) return null;

  const top = mine[0];
  const isMine = top.fromPlayerId === myPlayerId;
  const counterName = isMine ? top.toName : top.fromName;
  const game = getGame(top.gameId);
  const gameLabel = game?.label || top.gameId;

  let labelText;
  let onClick;
  if (top.status === 'pending') {
    labelText = isMine
      ? `🎯 You challenged ${counterName} to ${gameLabel} — Open`
      : `🎯 ${counterName} challenges you to ${gameLabel} — Open`;
    onClick = () => onOpenReview(top.id);
  } else if (top.status === 'active') {
    labelText = `⚔ Live: ${gameLabel} vs ${counterName} — Open`;
    onClick = () => onOpenActive(top.id);
  } else { // completed
    const won = top.winner === (isMine ? 'from' : 'to');
    const tie = top.winner === 'tie';
    labelText = tie
      ? `🤝 Draw vs ${counterName} (${gameLabel}) — Tap`
      : won
      ? `🏆 You beat ${counterName} at ${gameLabel} — Tap`
      : `💀 ${counterName} beat you at ${gameLabel} — Tap`;
    onClick = () => onOpenResult(top.id);
  }

  return (
    <button style={styles.banner} onClick={onClick}>
      <span style={styles.text}>{labelText}</span>
      {mine.length > 1 && <span style={styles.count}>+{mine.length - 1}</span>}
    </button>
  );
}

const styles = {
  banner: { width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '8px 12px', background: 'linear-gradient(180deg, rgba(122,87,184,0.25), rgba(74,52,120,0.25))', border: '1px solid #a987d4', color: '#f0e6d0', fontFamily: "'Press Start 2P', monospace", fontSize: 13, fontWeight: 700, cursor: 'pointer', letterSpacing: '0.04em', boxShadow: '0 2px 12px rgba(122,87,184,0.35)' },
  text:   { textAlign: 'center' },
  count:  { background: '#a987d4', color: '#1a0e00', fontWeight: 800, fontSize: 11, borderRadius: 8, padding: '0 6px' },
};
